import { ButtonDesignTokens } from '@primeuix/themes/types/button';
import { colors } from '../colors';

export const button: ButtonDesignTokens = {
  colorScheme: {
    dark: {
      root: {
        primary: {
          background: '{primary.500}',
          color: '{blue.500}',
        },
        secondary: {
          background: '{surface.500}',
          color: '{text-color}',
          borderColor: '{content.borderColor}',
          hoverBackground: '{primary.500}',
          hoverColor: '{button.primary.color}',
          hoverBorderColor: '{primary.500}',
        },
        contrast: {
          color: colors.textWeak,
          background: '{blue.500}',
          borderColor: colors.blue500,
          hoverBackground:
            'color-mix(in srgb,var(--p-surface-300),transparent 84%)',
          hoverColor: colors.textWeak,
          hoverBorderColor: colors.blue500,
        },
      },
      text: {
        // Datatable filter button is classified as text-secondary. These settings control the way it looks.
        secondary: {
          color: '{text-weak-color}',
          hoverBackground: '{blue.500}',
          activeBackground: '{blue.500}',
        },

        danger: {
          hoverBackground:
            'color-mix(in srgb,var(--p-red-400),transparent 84%)',
        },
      },
      outlined: {
        danger: {
          borderColor: '{red.400}',
          hoverBackground:
            'color-mix(in srgb,var(--p-red-400),transparent 84%)',
        },
      },
      link: {
        color: '{text.weakColor}',
        hoverColor: '{text.color}',
      },
    },
  },
};
